import React from 'react'
import CalloutSection from '../../UI/CalloutSection/CalloutSection'
import image from "../../../assets/images/academic-large--resized.jpg";
import classes from './AlumniQuote.module.css';

const AlumniQuote = (props) => (
  <CalloutSection
    image={image}
    alt="Dickinson themed boots"
  >
    <blockquote className={classes.Quote}>
      <p>
      “I wasn’t born to be a chemist. The fact that Dickinson encouraged me to get involved with many different things, to sample many different topics, was important, because I didn’t know what I wanted to do.” 
      </p>
      <cite>
      {/* --ONE OF THE WORLD’S FOREMOST EXPERTS IN NANOTECHNOLOGY, CHAD MIRKIN ’86 (CHEMISTRY), DIRECTOR OF NORTHWESTERN UNIVERSITY’S INTERNATIONAL INSTITUTE FOR NANOTECHNOLOGY, WINNER OF THE PRESTIGIOUS DAN DAVID PRIZE IN THE FUTURE TIME DIMENSION */}
      &mdash; One of the world's foremost experts in nanotechnology, Chad Mirkin '86 (Chemisty)<br />
      <span>Director of Northwestern University's International Institute for Nanotechnology<br /></span>
      <span>Winner of the prestigious Dan David prize in the future time dimension</span>

      </cite>
    </blockquote>
  </CalloutSection>
)

export default AlumniQuote